import React from 'react';
import { Helmet } from '@okapi/helmet-react';

export const ADVCAKE_SCRIPT_SRC = 'https://static.lemanapro.ru/products/p0511/lemanapro.ru.js';
export const ADVCAKE_SCRIPT_INTEGRITY =
  'sha384-sEBwOOilhJwCz6f57YnsSd+53iYv9NqN1CqnMHZTUhEhy+CVUaHp/A75SCN/I/Vj';

type AdvCakeScriptProps = {
  isKZDomain?: boolean;
};

export const AdvCakeScript = ({ isKZDomain }: AdvCakeScriptProps) =>
  isKZDomain ? null : (
    <Helmet>
      <script
        src={ADVCAKE_SCRIPT_SRC}
        integrity={ADVCAKE_SCRIPT_INTEGRITY}
        crossOrigin="anonymous"
        // HACK https://tracker.yandex.ru/ADTECH-1541
        async={'async' as never}
        id="adv-cake-script-id"
      />
    </Helmet>
  );
